// --- GSAP等の設定 ----
// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import { CustomEase } from "gsap/CustomEase.js";

gsap.registerPlugin(ScrollTrigger, CustomEase);




document.addEventListener('DOMContentLoaded', function (event) {

  if (document.querySelector('.js-snap-wrapper .js-snap .js-snap-item')) {
    const wrapper = document.querySelector('.js-snap-wrapper')
    const stage = wrapper.querySelector('.js-snap');
    const items = stage.querySelectorAll('.js-snap-item');
    let wh = window.innerheight;
    let ww = document.documentElement.clientWidth;

    // トップの4枚だけ。カードの top 0.5s ease-in-out と同じ時間・曲線で文字を動かす
    let setActiveSnapText = function () {};
    if (stage.querySelector('.js-snap-item.--04 .js-snap-text')) {
      const snapTexts = [];
      items.forEach((item) => {
        snapTexts.push(item.querySelector('.js-snap-text'));
      });
      const textDistance = ww > 768 ? 48 : 40;
      const textEase = CustomEase.create('snapTextEase', '0.42,0,0.58,1');

      snapTexts.forEach((text) => {
        if (text) {
          gsap.set(text, { autoAlpha: 0, y: textDistance });
        }
      });

      setActiveSnapText = function (index) {
        snapTexts.forEach((text, i) => {
          if (!text) {
            return;
          }
          let y = textDistance;
          let autoAlpha = 0;
          if (i === index) {
            y = 0;
            autoAlpha = 1;
          } else if (i < index) {
            y = -textDistance;
          }
          gsap.to(text, {
            autoAlpha: autoAlpha,
            y: y,
            duration: 0.5,
            ease: textEase,
            overwrite: 'auto',
          });
        });
      };

      ScrollTrigger.create({
        trigger: wrapper,
        start: 'top bottom',
        end: 'top top',
        onEnter: function () {
          setActiveSnapText(0);
        },
        onEnterBack: function () {
          setActiveSnapText(0);
        },
        onLeaveBack: function () {
          setActiveSnapText(-1);
        },
      });
    }

    ScrollTrigger.create({
      toggleActions: 'play pause resume reset',
      trigger: wrapper,
      start: `top top`,
      end: `bottom bottom`,
      onEnter: function () {
        stage.classList.add('--fixed');
      },
      onLeave: function () {
        stage.classList.remove('--fixed');
        stage.classList.add('--bottom');
      },
      onEnterBack: function () {
        stage.classList.remove('--bottom');
        stage.classList.add('--fixed');
      },
      onLeaveBack: function () {
        stage.classList.remove('--fixed');
      },
    });

    // 4枚のときだけ等間隔。3枚（About）は従来の位置のまま
    const isFourSteps = !!stage.querySelector('.js-snap-item.--04');
    const stepBreaks = isFourSteps
      ? (ww > 768 ? ['87.5%', '175%', '262.5%'] : ['112.5%', '225%', '337.5%'])
      : (ww > 768 ? ['40%', '120%', '170%'] : ['60%', '150%', '200%']);

    ScrollTrigger.create({
      toggleActions: 'play pause resume reset',
      trigger: wrapper,
      start: `top top`,
      end: `top top-=${stepBreaks[0]}`,
      // end: `top top-=40%`,
      onEnter: function () {
        stage.classList.add('--step01');
      },
      onLeave: function () {
        stage.classList.remove('--step01');
      },
      onEnterBack: function () {
        stage.classList.add('--step01');
        setActiveSnapText(0);
      },
      // markers: true,
      // onLeaveBack: function() {
      //   stage.classList.add('--step01');
      // },
    });

    ScrollTrigger.create({
      toggleActions: 'play pause resume reset',
      trigger: wrapper,
      start: `top top-=${stepBreaks[0]}`,
      end: `top top-=${stepBreaks[1]}`,
      onEnter: function () {
        stage.classList.add('--step02');
        setActiveSnapText(1);
        if (stage.querySelector('.js-snap-item.--02 .js-snap-inner')) {
          stage.querySelector('.js-snap-item.--02 .js-snap-inner').classList.add('is-show');
        }
      },
      onLeave: function () {
        stage.classList.remove('--step02');
        if (stage.querySelector('.js-snap-item.--02 .js-snap-inner')) {
          stage.querySelector('.js-snap-item.--02 .js-snap-inner').classList.remove('is-show');
        }
      },
      onEnterBack: function () {
        stage.classList.add('--step02');
        setActiveSnapText(1);
        if (stage.querySelector('.js-snap-item.--02 .js-snap-inner')) {
          stage.querySelector('.js-snap-item.--02 .js-snap-inner').classList.add('is-show');
        }
      },
      onLeaveBack: function () {
        stage.classList.remove('--step02');
        if (stage.querySelector('.js-snap-item.--02 .js-snap-inner')) {
          stage.querySelector('.js-snap-item.--02 .js-snap-inner').classList.remove('is-show');
        }
      },
      // markers: true,
    });

    ScrollTrigger.create({
      toggleActions: 'play pause resume reset',
      trigger: wrapper,
      start: `top top-=${stepBreaks[1]}`,
      end: `top top-=${stepBreaks[2]}`,
      onEnter: function () {
        stage.classList.add('--step03');
        setActiveSnapText(2);
        if (stage.querySelector('.js-snap-item.--03 .js-snap-inner')) {
          stage.querySelector('.js-snap-item.--03 .js-snap-inner').classList.add('is-show');
        }
      },
      onLeave: function () {
        stage.classList.remove('--step03');
        if (stage.querySelector('.js-snap-item.--03 .js-snap-inner')) {
          stage.querySelector('.js-snap-item.--03 .js-snap-inner').classList.remove('is-show');
        }
      },
      onEnterBack: function () {
        stage.classList.add('--step03');
        setActiveSnapText(2);
        if (stage.querySelector('.js-snap-item.--03 .js-snap-inner')) {
          stage.querySelector('.js-snap-item.--03 .js-snap-inner').classList.add('is-show');
        }
      },
      onLeaveBack: function () {
        stage.classList.remove('--step03');
        if (stage.querySelector('.js-snap-item.--03 .js-snap-inner')) {
          stage.querySelector('.js-snap-item.--03 .js-snap-inner').classList.remove('is-show');
        }
      },
    });

    // 4項目ある場合のみ。3項目ページ（About）では --step03 までを維持する
    if (isFourSteps) {
      ScrollTrigger.create({
        toggleActions: 'play pause resume reset',
        trigger: wrapper,
        start: `top top-=${stepBreaks[2]}`,
        end: `bottom bottom`,
        onEnter: function () {
          stage.classList.add('--step04');
          setActiveSnapText(3);
          if (stage.querySelector('.js-snap-item.--04 .js-snap-inner')) {
            stage.querySelector('.js-snap-item.--04 .js-snap-inner').classList.add('is-show');
          }
        },
        onEnterBack: function () {
          stage.classList.add('--step04');
          setActiveSnapText(3);
          if (stage.querySelector('.js-snap-item.--04 .js-snap-inner')) {
            stage.querySelector('.js-snap-item.--04 .js-snap-inner').classList.add('is-show');
          }
        },
        onLeaveBack: function () {
          stage.classList.remove('--step04');
          if (stage.querySelector('.js-snap-item.--04 .js-snap-inner')) {
            stage.querySelector('.js-snap-item.--04 .js-snap-inner').classList.remove('is-show');
          }
        },
      });
    }


    // let wrapperTop = Math.floor(stage.getBoundingClientRect().top + window.scrollY);
    // let wrapperBottom = Math.floor(wrapperTop + stage.clientHeight);
    // let setSnap = true;
    // // console.log(wh);
    // for (let item of items) {
    //   // console.log(item.clientHeight);
    //   if (wh < item.clientHeight) {
    //     setSnap = false;
    //     break;
    //   }
    // }


    // PC&wh > chならば
    // if (ww > 999) {
    //   if (setSnap) {

    //     window.addEventListener('load', reset);
    //     window.addEventListener('resize', reset);

    //     // wheelのdeltaYが小さいトラックパッド等の場合、スクロール待機時間を延ばす
    //     window.addEventListener('wheel', wheelJudge);

    //     // スクロールスナップの起動
    //     setScrollSnap();


    //   } else {
    //     // wrapperに.--no-snapを設定
    //     stage.classList.add('--no-snap');

    //     setEffectWithoutSnap();

    //     // アンカーリンクのスムーススクロール（スクロールスナップがない場合）
    //     const headerHeight = window.innerWidth > 768 ? jQuery('header').innerHeight() : 0; // ヘッダー追従の場合 // if header following
    //     jQuery('a[href^="#"]').click(function () {
    //       const href = jQuery(this).attr("href");
    //       const target = jQuery(href == "#" || href == "" ? 'html' : href);
    //       if (target.length > 0) {
    //         const position = target.offset().top - headerHeight;
    //         jQuery("html, body").animate({ scrollTop: position }, 550, "swing");
    //         return false;
    //       }
    //     });

    //   }
    // } else {

    //   setEffectWithoutSnap();

    //   // アンカーリンクのスムーススクロール（スクロールスナップがない場合）
    //   const headerHeight = window.innerWidth > 768 ? jQuery('header').innerHeight() : 0; // ヘッダー追従の場合 // if header following
    //   jQuery('a[href^="#"]').click(function () {
    //     const href = jQuery(this).attr("href");
    //     const target = jQuery(href == "#" || href == "" ? 'html' : href);
    //     if (target.length > 0) {
    //       const position = target.offset().top - headerHeight;
    //       jQuery("html, body").animate({ scrollTop: position }, 550, "swing");
    //       return false;
    //     }
    //   });
    // }

    // let scrollTrigger;
    // function setScrollSnap() {

    //   // positionまで来たら画面固定
    //   scrollTrigger = ScrollTrigger.create({
    //     toggleActions: 'play pause resume reset',
    //     trigger: wrapper,
    //     start: `top center`,
    //     end: `bottom center`,
    //     // scrub: true,
    //     onEnter: function() {
    //       // console.log('enter')

    //       if (window.scrollY < wrapperTop) {

    //         // 画面固定
    //         fixWindow();

    //         // 移動
    //         gsap.to(window, {
    //           scrollTo: {
    //             y: Math.floor(wrapper.getBoundingClientRect().top + window.scrollY),
    //             autoKill: false
    //           },
    //           duration: 0.5,
    //           ease: 'power2.out',
    //           onComplete: function() {
    //             wrapper.querySelector('.js-snap-item.--01').classList.add('is-show');
    //           }
    //         });


    //         // ページ送りエフェクト設定
    //         window.setTimeout(function() {
    //           window.addEventListener('wheel', snapScrollHandler, false);
    //         }, 800);

    //       }

    //     },
    //     onEnterBack: function() {
    //       // console.log('enterBack')


    //       if (window.scrollY > wrapperTop) {

    //         // 画面固定
    //         fixWindow();

    //         // 移動
    //         gsap.to(window, {
    //           scrollTo: {
    //             y: Math.floor(wrapper.getBoundingClientRect().top + window.scrollY),
    //             autoKill: false
    //           },
    //           duration: 0.5,
    //           ease: 'power2.out',
    //           onComplete: function() {
    //             wrapper.querySelector('.js-snap-item.--03').classList.add('is-show');
    //           }
    //         });

    //         // ページ送りエフェクト設定
    //         window.setTimeout(function() {
    //           window.addEventListener('wheel', snapScrollHandler);
    //         }, 800);
    //       }
    //     },
    //   })

    //   // 最後のis-showを除く
    //   ScrollTrigger.create({
    //     trigger: wrapper,
    //     start: 'top bottom',
    //     end: 'bottom top',
    //     onLeave: function() {
    //       // console.log('leave')
    //       for (let item of items) {
    //         item.classList.remove('is-show');
    //       }
    //     },
    //     onLeaveBack: function() {
    //       // console.log('leaveBack')
    //       for (let item of items) {
    //         item.classList.remove('is-show');
    //       }
    //     },
    //   })

    //   // アンカーリンク対応
    //   const headerHeight = window.innerWidth > 768 ? jQuery('header').innerHeight() : 0; // ヘッダー追従の場合 // if header following
    //   jQuery('a[href^="#"]').click(function () {
    //     const href = jQuery(this).attr("href");
    //     const target = jQuery(href == "#" || href == "" ? 'html' : href);
    //     if (target.length > 0) {
    //       const position = target.offset().top - headerHeight;
    //       scrollTrigger.disable();

    //       // #featureへの遷移の場合
    //       if (target.id === 'feature') {
    //         wrapper.classList.remove('--step02', '--step03');
    //       }

    //       jQuery("html, body").animate({ scrollTop: position }, 550, "swing")
    //         .promise()
    //         .done(function() {
    //           resetSnapItem();
    //           scrollTrigger.enable();
    //         });
    //       return false;
    //     }
    //   });


    // }

    // // 画面スクロール禁止
    // function fixWindow() {
    //   document.body.style.overflow = 'hidden';
    // }
    // function clearFixedWindow() {
    //   document.body.style.overflow = '';
    // }

    // // ページ送りエフェクト
    // let underSnap = false;
    // let time_wait_scroll = 600;
    // const DURATION_ITEM_MOVE = 500;
    // function snapScrollHandler(e) {
    //   if (!underSnap) {
    //     underSnap = true;
    //     if (e.deltaY < 0) {  // 上スクロール
    //       // console.log('ue')
    //       if (wrapper.classList.contains('--step03')) {
    //         wrapper.classList.add('--step02');
    //         wrapper.classList.remove('--step03');
    //         setTimeout(function() {
    //           wrapper.querySelector('.js-snap-item.--02').classList.add('is-show');
    //           wrapper.querySelector('.js-snap-item.--03').classList.remove('is-show');
    //         }, DURATION_ITEM_MOVE);
    //         setAllowScrollTimer();
    //       } else if (wrapper.classList.contains('--step02')) {
    //         wrapper.classList.remove('--step02');
    //         setTimeout(function() {
    //           wrapper.querySelector('.js-snap-item.--01').classList.add('is-show');
    //           wrapper.querySelector('.js-snap-item.--02').classList.remove('is-show');
    //         }, DURATION_ITEM_MOVE);
    //         setAllowScrollTimer();
    //       } else {
    //         gsap.to(window, {
    //           scrollTo: {
    //             y: Math.floor(wrapper.getBoundingClientRect().top + window.scrollY - wh * 0.55),
    //             autoKill: false
    //           },
    //           duration: 0.5,
    //           ease: 'power2.out',
    //           onComplete: function() {
    //             window.removeEventListener('wheel', snapScrollHandler);
    //             underSnap = false;
    //             clearFixedWindow();
    //           }
    //         });
    //       }
    //     } else if (e.deltaY > 0) {  // 下スクロール
    //       // console.log('shita')
    //       if (wrapper.classList.contains('--step03')) {
    //         gsap.to(window, {
    //           scrollTo: {
    //             y: Math.floor(wrapper.getBoundingClientRect().top + window.scrollY + wrapper.clientHeight - wh * 0.45),
    //             autoKill: false
    //           },
    //           duration: 0.5,
    //           ease: 'power2.out',
    //           onComplete: function() {
    //             window.removeEventListener('wheel', snapScrollHandler);
    //             underSnap = false;
    //             clearFixedWindow();
    //           }
    //         });
    //       } else if (wrapper.classList.contains('--step02')) {
    //         wrapper.classList.add('--step03');
    //         wrapper.classList.remove('--step02');
    //         setTimeout(function() {
    //           wrapper.querySelector('.js-snap-item.--03').classList.add('is-show');
    //           wrapper.querySelector('.js-snap-item.--02').classList.remove('is-show');
    //         }, DURATION_ITEM_MOVE);
    //         setAllowScrollTimer();
    //       } else {
    //         wrapper.classList.add('--step02');
    //         setTimeout(function() {
    //           wrapper.querySelector('.js-snap-item.--02').classList.add('is-show');
    //           wrapper.querySelector('.js-snap-item.--01').classList.remove('is-show');
    //         }, DURATION_ITEM_MOVE);
    //         setAllowScrollTimer();
    //       }
    //     }
    //   }
    // }
    // function setAllowScrollTimer() {
    //   window.setTimeout(function() {
    //     underSnap = false;
    //   }, time_wait_scroll)
    // }

    // // deltaYが小さいトラックパッド等の場合、スクロール待機時間を延ばす
    // function wheelJudge(e) {
    //   if (e.deltaMode === 0 && Math.abs(e.deltaY) < 10) {
    //     // console.log('トラックパッド')
    //     time_wait_scroll = 1200;
    //   } 
    //   // else {
    //   //   console.log(e.deltaY)
    //   // }
    //   window.removeEventListener('wheel', wheelJudge);
    // }

    // // 現在地を元にページ状態をリセットする
    // function resetSnapItem() {
    //   const scroll = window.scrollY;
    //   if (scroll < wrapperTop) {
    //     wrapper.classList.remove('--step02', '--step03');
    //     // wrapper.querySelector('.js-snap-item.--01').classList.add('is-show');
    //     // wrapper.querySelector('.js-snap-item.--02').classList.remove('is-show');
    //     // wrapper.querySelector('.js-snap-item.--03').classList.remove('is-show');
    //     for (let item of items) {
    //       item.classList.remove('is-show');
    //     }
    //   } else if (scroll > wrapperBottom) {
    //     wrapper.classList.add('--step03');
    //     wrapper.classList.remove('--step02');
    //     // wrapper.querySelector('.js-snap-item.--01').classList.remove('is-show');
    //     // wrapper.querySelector('.js-snap-item.--02').classList.remove('is-show');
    //     // wrapper.querySelector('.js-snap-item.--03').classList.add('is-show');
    //     for (let item of items) {
    //       item.classList.remove('is-show');
    //     }
    //   }
    // }

    // // 各種パラメータ更新
    // function reset(e) {
    //   wh = window.innerHeight;
    //   ww = window.innerWidth;
    //   wrapperTop = Math.floor(wrapper.getBoundingClientRect().top + window.scrollY);
    //   wrapperBottom = Math.floor(wrapperTop + wrapper.clientHeight);
    //   resetSnapItem();
    // }

    // // スナップしない場合のエフェクト起動
    // function setEffectWithoutSnap() {
    //   items.forEach(item => {
    //     ScrollTrigger.create({
    //       trigger: item,
    //       start: 'top center',
    //       // end: 'bottom top',
    //       onEnter: function() {
    //         item.classList.add('is-show');
    //       },
    //       onEnterBack: function() {
    //         item.classList.add('is-show');
    //       },
    //     })

    //     ScrollTrigger.create({
    //       trigger: item,
    //       start: 'top bottom',
    //       end: 'bottom top',
    //       onLeave: function() {
    //         item.classList.remove('is-show');
    //       },
    //       onLeaveBack: function() {
    //         item.classList.remove('is-show');
    //       },
    //     })
    //   })

    // }

  }

  // if (document.querySelector('.js-snap .js-snap-item')) {
  //   const wrapper = document.querySelector('.js-snap');
  //   const items = wrapper.querySelectorAll('.js-snap-item');
  //   let wh = window.innerHeight;
  //   let ww = window.innerWidth;
  //   let wrapperTop = Math.floor(wrapper.getBoundingClientRect().top + window.scrollY);
  //   let wrapperBottom = Math.floor(wrapperTop + wrapper.clientHeight);
  //   let setSnap = true;
  //   // console.log(wh);
  //   for (let item of items) {
  //     // console.log(item.clientHeight);
  //     if (wh < item.clientHeight) {
  //       setSnap = false;
  //       break;
  //     }
  //   }


  //   // PC&wh > chならば
  //   if (ww > 999) {
  //     if (setSnap) {

  //       window.addEventListener('load', reset);
  //       window.addEventListener('resize', reset);

  //       // wheelのdeltaYが小さいトラックパッド等の場合、スクロール待機時間を延ばす
  //       window.addEventListener('wheel', wheelJudge);

  //       // スクロールスナップの起動
  //       setScrollSnap();


  //     } else {
  //       // wrapperに.--no-snapを設定
  //       wrapper.classList.add('--no-snap');

  //       setEffectWithoutSnap();

  //       // アンカーリンクのスムーススクロール（スクロールスナップがない場合）
  //       const headerHeight = window.innerWidth > 768 ? jQuery('header').innerHeight() : 0; // ヘッダー追従の場合 // if header following
  //       jQuery('a[href^="#"]').click(function () {
  //         const href = jQuery(this).attr("href");
  //         const target = jQuery(href == "#" || href == "" ? 'html' : href);
  //         if (target.length > 0) {
  //           const position = target.offset().top - headerHeight;
  //           jQuery("html, body").animate({ scrollTop: position }, 550, "swing");
  //           return false;
  //         }
  //       });

  //     }
  //   } else {

  //     setEffectWithoutSnap();

  //     // アンカーリンクのスムーススクロール（スクロールスナップがない場合）
  //     const headerHeight = window.innerWidth > 768 ? jQuery('header').innerHeight() : 0; // ヘッダー追従の場合 // if header following
  //     jQuery('a[href^="#"]').click(function () {
  //       const href = jQuery(this).attr("href");
  //       const target = jQuery(href == "#" || href == "" ? 'html' : href);
  //       if (target.length > 0) {
  //         const position = target.offset().top - headerHeight;
  //         jQuery("html, body").animate({ scrollTop: position }, 550, "swing");
  //         return false;
  //       }
  //     });
  //   }

  //   let scrollTrigger;
  //   function setScrollSnap() {

  //     // positionまで来たら画面固定
  //     scrollTrigger = ScrollTrigger.create({
  //       toggleActions: 'play pause resume reset',
  //       trigger: wrapper,
  //       start: `top center`,
  //       end: `bottom center`,
  //       // scrub: true,
  //       onEnter: function() {
  //         // console.log('enter')

  //         if (window.scrollY < wrapperTop) {

  //           // 画面固定
  //           fixWindow();

  //           // 移動
  //           gsap.to(window, {
  //             scrollTo: {
  //               y: Math.floor(wrapper.getBoundingClientRect().top + window.scrollY),
  //               autoKill: false
  //             },
  //             duration: 0.5,
  //             ease: 'power2.out',
  //             onComplete: function() {
  //               wrapper.querySelector('.js-snap-item.--01').classList.add('is-show');
  //             }
  //           });


  //           // ページ送りエフェクト設定
  //           window.setTimeout(function() {
  //             window.addEventListener('wheel', snapScrollHandler, false);
  //           }, 800);

  //         }

  //       },
  //       onEnterBack: function() {
  //         // console.log('enterBack')


  //         if (window.scrollY > wrapperTop) {

  //           // 画面固定
  //           fixWindow();

  //           // 移動
  //           gsap.to(window, {
  //             scrollTo: {
  //               y: Math.floor(wrapper.getBoundingClientRect().top + window.scrollY),
  //               autoKill: false
  //             },
  //             duration: 0.5,
  //             ease: 'power2.out',
  //             onComplete: function() {
  //               wrapper.querySelector('.js-snap-item.--03').classList.add('is-show');
  //             }
  //           });

  //           // ページ送りエフェクト設定
  //           window.setTimeout(function() {
  //             window.addEventListener('wheel', snapScrollHandler);
  //           }, 800);
  //         }
  //       },
  //     })

  //     // 最後のis-showを除く
  //     ScrollTrigger.create({
  //       trigger: wrapper,
  //       start: 'top bottom',
  //       end: 'bottom top',
  //       onLeave: function() {
  //         // console.log('leave')
  //         for (let item of items) {
  //           item.classList.remove('is-show');
  //         }
  //       },
  //       onLeaveBack: function() {
  //         // console.log('leaveBack')
  //         for (let item of items) {
  //           item.classList.remove('is-show');
  //         }
  //       },
  //     })

  //     // アンカーリンク対応
  //     const headerHeight = window.innerWidth > 768 ? jQuery('header').innerHeight() : 0; // ヘッダー追従の場合 // if header following
  //     jQuery('a[href^="#"]').click(function () {
  //       const href = jQuery(this).attr("href");
  //       const target = jQuery(href == "#" || href == "" ? 'html' : href);
  //       if (target.length > 0) {
  //         const position = target.offset().top - headerHeight;
  //         scrollTrigger.disable();

  //         // #featureへの遷移の場合
  //         if (target.id === 'feature') {
  //           wrapper.classList.remove('--step02', '--step03');
  //         }

  //         jQuery("html, body").animate({ scrollTop: position }, 550, "swing")
  //           .promise()
  //           .done(function() {
  //             resetSnapItem();
  //             scrollTrigger.enable();
  //           });
  //         return false;
  //       }
  //     });


  //   }

  //   // 画面スクロール禁止
  //   function fixWindow() {
  //     document.body.style.overflow = 'hidden';
  //   }
  //   function clearFixedWindow() {
  //     document.body.style.overflow = '';
  //   }

  //   // ページ送りエフェクト
  //   let underSnap = false;
  //   let time_wait_scroll = 600;
  //   const DURATION_ITEM_MOVE = 500;
  //   function snapScrollHandler(e) {
  //     if (!underSnap) {
  //       underSnap = true;
  //       if (e.deltaY < 0) {  // 上スクロール
  //         // console.log('ue')
  //         if (wrapper.classList.contains('--step03')) {
  //           wrapper.classList.add('--step02');
  //           wrapper.classList.remove('--step03');
  //           setTimeout(function() {
  //             wrapper.querySelector('.js-snap-item.--02').classList.add('is-show');
  //             wrapper.querySelector('.js-snap-item.--03').classList.remove('is-show');
  //           }, DURATION_ITEM_MOVE);
  //           setAllowScrollTimer();
  //         } else if (wrapper.classList.contains('--step02')) {
  //           wrapper.classList.remove('--step02');
  //           setTimeout(function() {
  //             wrapper.querySelector('.js-snap-item.--01').classList.add('is-show');
  //             wrapper.querySelector('.js-snap-item.--02').classList.remove('is-show');
  //           }, DURATION_ITEM_MOVE);
  //           setAllowScrollTimer();
  //         } else {
  //           gsap.to(window, {
  //             scrollTo: {
  //               y: Math.floor(wrapper.getBoundingClientRect().top + window.scrollY - wh * 0.55),
  //               autoKill: false
  //             },
  //             duration: 0.5,
  //             ease: 'power2.out',
  //             onComplete: function() {
  //               window.removeEventListener('wheel', snapScrollHandler);
  //               underSnap = false;
  //               clearFixedWindow();
  //             }
  //           });
  //         }
  //       } else if (e.deltaY > 0) {  // 下スクロール
  //         // console.log('shita')
  //         if (wrapper.classList.contains('--step03')) {
  //           gsap.to(window, {
  //             scrollTo: {
  //               y: Math.floor(wrapper.getBoundingClientRect().top + window.scrollY + wrapper.clientHeight - wh * 0.45),
  //               autoKill: false
  //             },
  //             duration: 0.5,
  //             ease: 'power2.out',
  //             onComplete: function() {
  //               window.removeEventListener('wheel', snapScrollHandler);
  //               underSnap = false;
  //               clearFixedWindow();
  //             }
  //           });
  //         } else if (wrapper.classList.contains('--step02')) {
  //           wrapper.classList.add('--step03');
  //           wrapper.classList.remove('--step02');
  //           setTimeout(function() {
  //             wrapper.querySelector('.js-snap-item.--03').classList.add('is-show');
  //             wrapper.querySelector('.js-snap-item.--02').classList.remove('is-show');
  //           }, DURATION_ITEM_MOVE);
  //           setAllowScrollTimer();
  //         } else {
  //           wrapper.classList.add('--step02');
  //           setTimeout(function() {
  //             wrapper.querySelector('.js-snap-item.--02').classList.add('is-show');
  //             wrapper.querySelector('.js-snap-item.--01').classList.remove('is-show');
  //           }, DURATION_ITEM_MOVE);
  //           setAllowScrollTimer();
  //         }
  //       }
  //     }
  //   }
  //   function setAllowScrollTimer() {
  //     window.setTimeout(function() {
  //       underSnap = false;
  //     }, time_wait_scroll)
  //   }

  //   // deltaYが小さいトラックパッド等の場合、スクロール待機時間を延ばす
  //   function wheelJudge(e) {
  //     if (e.deltaMode === 0 && Math.abs(e.deltaY) < 10) {
  //       // console.log('トラックパッド')
  //       time_wait_scroll = 1200;
  //     } 
  //     // else {
  //     //   console.log(e.deltaY)
  //     // }
  //     window.removeEventListener('wheel', wheelJudge);
  //   }

  //   // 現在地を元にページ状態をリセットする
  //   function resetSnapItem() {
  //     const scroll = window.scrollY;
  //     if (scroll < wrapperTop) {
  //       wrapper.classList.remove('--step02', '--step03');
  //       // wrapper.querySelector('.js-snap-item.--01').classList.add('is-show');
  //       // wrapper.querySelector('.js-snap-item.--02').classList.remove('is-show');
  //       // wrapper.querySelector('.js-snap-item.--03').classList.remove('is-show');
  //       for (let item of items) {
  //         item.classList.remove('is-show');
  //       }
  //     } else if (scroll > wrapperBottom) {
  //       wrapper.classList.add('--step03');
  //       wrapper.classList.remove('--step02');
  //       // wrapper.querySelector('.js-snap-item.--01').classList.remove('is-show');
  //       // wrapper.querySelector('.js-snap-item.--02').classList.remove('is-show');
  //       // wrapper.querySelector('.js-snap-item.--03').classList.add('is-show');
  //       for (let item of items) {
  //         item.classList.remove('is-show');
  //       }
  //     }
  //   }

  //   // 各種パラメータ更新
  //   function reset(e) {
  //     wh = window.innerHeight;
  //     ww = window.innerWidth;
  //     wrapperTop = Math.floor(wrapper.getBoundingClientRect().top + window.scrollY);
  //     wrapperBottom = Math.floor(wrapperTop + wrapper.clientHeight);
  //     resetSnapItem();
  //   }

  //   // スナップしない場合のエフェクト起動
  //   function setEffectWithoutSnap() {
  //     items.forEach(item => {
  //       ScrollTrigger.create({
  //         trigger: item,
  //         start: 'top center',
  //         // end: 'bottom top',
  //         onEnter: function() {
  //           item.classList.add('is-show');
  //         },
  //         onEnterBack: function() {
  //           item.classList.add('is-show');
  //         },
  //       })

  //       ScrollTrigger.create({
  //         trigger: item,
  //         start: 'top bottom',
  //         end: 'bottom top',
  //         onLeave: function() {
  //           item.classList.remove('is-show');
  //         },
  //         onLeaveBack: function() {
  //           item.classList.remove('is-show');
  //         },
  //       })
  //     })

  //   }

  // } else {
  //   // アンカーリンクのスムーススクロール（スクロールスナップがない場合）
  //   const headerHeight = window.innerWidth > 768 ? jQuery('header').innerHeight() : 0; // ヘッダー追従の場合 // if header following
  //   jQuery('a[href^="#"]').click(function () {
  //     const href = jQuery(this).attr("href");
  //     const target = jQuery(href == "#" || href == "" ? 'html' : href);
  //     if (target.length > 0) {
  //       const position = target.offset().top - headerHeight;
  //       jQuery("html, body").animate({ scrollTop: position }, 550, "swing");
  //       return false;
  //     }
  //   });
  // }

});

